import { UrlParams, KeyValuePair, UrlParamsContact } from "../redux/types";

const enaProducts: KeyValuePair =
{
  'EA1' : 'KONE MonoSpace® 300 DX',
  'EGC' : 'KONE EcoSpace™',
  'EUN' : 'KONE MonoSpace® 500 DX',
  'EKE' : 'KONE MonoSpace® 700 DX',
  'EVE' : 'KONE MiniSpace™ DX',
  'EOP' : 'KONE MonoSpace® 300 DX',
  'ELZ' : 'KONE EcoSpace™',
  'EST' : 'KONE MonoSpace® 500 DX',
  'EWR' : 'KONE MonoSpace® 700 DX',
  'EFG': 'KONE MiniSpace™ DX',
}

const productMapping:KeyValuePair = 
{
  'ADE' : 'KONE TravelMaster™ 110T',
  'KJL' : 'KONE TravelMaster™ 110',
  'LKE' : 'KONE TransitMaster™ 120T',
  'GMR' : 'KONE TransitMaster™ 120',
  'HIL' : 'KONE TransitMaster™ 180',
  'AMO' : 'KONE TransitMaster™ 210',
  'HCM' : 'KONE TransitMaster™ 220',
  'TRZ' : 'KONE TravelMaster™ 115',
  'YAR' : 'KONE TransitMaster™ 140',
  'DWB' : 'KONE TransitMaster™ 165',

  'AZ4' : 'KONE MonoSpace® 300 DX',
  'F3B' : 'KONE MonoSpace® 500 DX',
  '4C2' : 'KONE MonoSpace® 550 DX',
  'U8M' : 'KONE MonoSpace® 700 DX',
  '9P7' : 'KONE Transys™ DX',
  'JK1' : 'KONE MiniSpace™',
  'H3W' : 'KONE N MonoSpace®',
  'M8C' : 'KONE S MonoSpace®',
  'L0C' : 'KONE E MonoSpace®',
  'Z4T' : 'KONE N MiniSpace™',
  'BM2' : 'KONE 3000 MiniSpace™',
  'CO7' : 'KONE E MiniSpace™ DX',

  // India
  'AWM' : 'KONE I MonoSpace®',
  'SKS' : 'KONE I MiniSpace™',
  'RSA' : 'KONE A MonoSpace®',
  'PFG' : 'KONE A MiniSpace™',
  'VST' : 'KONE U MonoSpace®',
  'QYP' : 'KONE U MiniSpace™',
  '1KL' : 'KONE N MonoSpace® DX KEA',
  '36S' : 'KONE S MonoSpace® DX KEA',
  'XGJ' : 'KONE E MonoSpace® DX KEA',
  'TT5' : 'KONE N MiniSpace™ DX KEA',

  // ena
  ...enaProducts
}


const cardesignerMapping:KeyValuePair = 
{
  'AZ4' : 'monospace-300',
  'F3B' : 'monospace-500',
  '4C2' : 'monospace-550',
  'U8M' : 'monospace-700',
  'M1' : 'monospace-300',
  'M3' : 'monospace-500',
  'M4' : 'monospace-550',
  'EX' : 'monospace-700',
  'JK1' : 'minispace',
  'H3W' : 'n-monospace',
  'M8C' : 's-monospace',
  'L0C' : 'e-monospace',
  'Z4T' : 'n-minispace',
  'BM2' : 'minispace-exp',
  'PT2' : 'minispace-exp',
  'CO7' : 'e-minispace',
  'PTE' : 'e-minispace',

  // India
  // 'AWM' : 'i-monospace',
  // 'SKS' : 'i-minispace',
  
  '1KL' : 'n-monospace-exp',
  'NMO' : 'n-monospace-exp',
  '36S' : 's-monospace-exp',
  'PWS1' : 's-monospace-exp',
  'XGJ' : 'e-monospace-exp',
  'PWE' : 'e-monospace-exp',
  'TT5' : 'n-minispace-exp',
  'NMI' : 'n-minispace-exp',

  // ena
  'EA1' : 'monospace-300-ena',
  'EUN' : 'monospace-500-ena',
  'EKE' : 'monospaca-700-ena',
  'EVE' : 'minispace-ena',
  'EOP' : 'monospace-300-ena',
  'EST' : 'monospace-500-ena',
  'EWR' : 'monospace-700-ena',
  'M3NA' : 'monospace-300-ena',
  'FNO' : 'monospace-500-ena',
  'EX1' : 'monospace-700-ena',
  'EFG' : 'minispace-ena',
  'EM1' : 'minispace-ena',

}

const typeMapping:KeyValuePair = 
{
  'ADE' : 'escalator',
  'KJL' : 'escalator',
  'LKE' : 'escalator',
  'GMR' : 'escalator',
  'HIL' : 'escalator',
  'AMO' : 'escalator',
  'HCM' : 'escalator',
  'TRZ' : 'escalator',
  'YAR' : 'escalator',
  'DWB' : 'escalator',

  'AZ4' : 'elevator',
  'F3B' : 'elevator',
  '4C2' : 'elevator',
  'U8M' : 'elevator',
  '9P7' : 'elevator',
  'JK1' : 'elevator',
  'H3W' : 'elevator',
  'M8C' : 'elevator',
  'L0C' : 'elevator',
  'Z4T' : 'elevator',
  'BM2' : 'elevator',
  'CO7' : 'elevator',
  'AWM' : 'elevator',
  'SKS' : 'elevator',
  'RSA' : 'elevator',
  'PFG' : 'elevator',
  'VST' : 'elevator',
  'QYP' : 'elevator',
  '1KL' : 'elevator',
  '36S' : 'elevator',
  'XGJ' : 'elevator',
  'TT5' : 'elevator',

  'EA1' : 'elevator',
  'EGC' : 'elevator',
  'EUN' : 'elevator',
  'EKE' : 'elevator',
  'EVE' : 'elevator',
  'EOP' : 'elevator',
  'ELZ' : 'elevator',
  'EST' : 'elevator',
  'EWR' : 'elevator',
  'EFG' : 'elevator',

}

const releaseMapping:KeyValuePair =
{
  '1': '19.2',
  '2': '20.1',
  '3': '20.2',
  '4': '21.1',
  '5': '21.2',
  '6': '22.1',
}

const plannerMapping:KeyValuePair[] = 
  [
    // {
    //   'planner':'elevatorplanner.kone.us', 
    //   'studio':'https://www.kone.us/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.ca', 
    //   'studio':'https://www.kone.ca/en/studio/tool/#/welcome'
    // },
    {
      'planner':'liftplanner.kone.co.uk', 
      'studio':'https://www.kone.co.uk/studio/tool/#/welcome'
    },
    {
      'planner':'liftconfigurator.kone.ie', 
      'studio':'https://www.kone.ie/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.pl', 
      'studio':'https://www.kone.pl/studio/tool/#/welcome'
    },
    {
      'planner':'aufzug-konfigurator.kone.de', 
      'studio':'https://www.kone.de/studio/tool/#/welcome'
    },
    {
      'planner':'aufzug-planer.kone.de', 
      'studio':'https://www.kone.de/studio/tool/#/welcome'
    },
    {
      'planner':'aufzugplaner.kone.at', 
      'studio':'https://www.kone.at/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.se', 
      'studio':'https://www.kone.se/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.dk', 
      'studio':'https://www.kone.dk/studio/tool/#/welcome'
    },
    {
      'planner':'heiskonfigurator.kone.no', 
      'studio':'https://www.kone.no/studio/tool/#/welcome'
    },
    {
      'planner':'lyftuhonnun.kone.is', 
      'studio':'https://www.kone.is/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.fi', 
      'studio':'https://www.kone.fi/studio/tool/#/welcome'
    },
    {
      'planner':'hissisuunnittelu.kone.fi', 
      'studio':'https://www.kone.fi/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.hu', 
      'studio':'https://www.kone.hu/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.cz', 
      'studio':'https://www.kone.cz/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.sk', 
      'studio':'https://www.kone.sk/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.be', 
      'studio':'https://www.kone.be/fr/studio/tool/#/welcome'
    },
    {
      'planner':'plannerascenseurs.kone.fr', 
      'studio':'https://www.kone.fr/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.it', 
      'studio':'https://www.kone.it/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.ee', 
      'studio':'https://www.kone.ee/studio/tool/#/welcome'
    },
    {
      'planner':'liftconfigurator.kone.nl', 
      'studio':'https://www.kone.nl/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.co.il', 
      'studio':'https://www.kone.co.il/he/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.ua', 
      'studio':'https://www.kone.ua/ua/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.si', 
      'studio':'https://www.kone.si/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.lt', 
      'studio':'https://www.kone.lt/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.lv', 
      'studio':'https://www.kone.lv/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.mk', 
      'studio':'https://www.kone.mk/en/studio/tool/#/welcome'
    },
    // {
    //   'planner':'elevatorplanner.kone.ma', 
    //   'studio':'https://www.kone.ma/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.co.ke', 
    //   'studio':'https://www.kone.co.ke/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.ug', 
    //   'studio':'https://www.kone.ug/studio/tool/#/welcome'
    // },
    {
      'planner':'elevatorplanner.kone.gr', 
      'studio':'https://www.kone.gr/el/studio/tool/#/welcome'
    },
    // {
    //   'planner':'elevatorplanner.kone.co.za', 
    //   'studio':'https://www.kone.co.za/studio/tool/#/welcome'
    // },
    {
      'planner':'elevatorplanner.kone.es', 
      'studio':'https://www.kone.es/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.pt', 
      'studio':'https://www.kone.pt/studio/tool/#/welcome'
    },
    // {
    //   'planner':'elevatorplanner.kone.com.tr', 
    //   'studio':'https://www.kone.com.tr/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.eg', 
    //   'studio':'https://www.kone.eg/en/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.ae', 
    //   'studio':'https://www.kone.ae/en/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.sa', 
    //   'studio':'https://www.kone.sa/en/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.bh', 
    //   'studio':'https://www.kone.bh/en/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.qa', 
    //   'studio':'https://www.kone.qa/en/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.om', 
    //   'studio':'https://www.kone.om/en/studio/tool/#/welcome'
    // },
    {
      'planner':'elevatorplanner.kone.bg', 
      'studio':'https://www.kone.bg/bg/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.hr', 
      'studio':'https://www.kone.hr/hr/studio/tool/#/welcome'
    },
    {
      'planner':'liftplanner.kone.com.cy', 
      'studio':'https://www.kone.com.cy/en/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.me', 
      'studio':'https://www.kone.me/en/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.com.ro', 
      'studio':'https://www.kone.com.ro/ro/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.rs', 
      'studio':'https://www.kone.rs/sr/studio/tool/#/welcome'
    },
    {
      'planner':'elevatorplanner.kone.ba', 
      'studio':'https://www.kone.ba/en/studio/tool/#/welcome'
    },
    // {
    //   'planner':'elevatorplanner.kone.kz', 
    //   'studio':'https://www.kone.kz/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.tn', 
    //   'studio':'https://www.kone.tn/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.com.kw', 
    //   'studio':'https://www.kone.com.kw/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.mx', 
    //   'studio':'https://www.kone.mx/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.com.au', 
    //   'studio':'https://www.kone.com.au/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.co.nz', 
    //   'studio':'https://www.kone.co.nz/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.sg', 
    //   'studio':'https://www.kone.sg/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.my', 
    //   'studio':'https://www.kone.my/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.co.id', 
    //   'studio':'https://www.kone.co.id/id/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.ph', 
    //   'studio':'https://www.kone.ph/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.co.th', 
    //   'studio':'https://www.kone.co.th/th/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'elevatorplanner.kone.vn', 
    //   'studio':'https://www.kone.vn/vi/studio/tool/#/welcome'
    // },
    // {
    //   'planner':'commonelevatorplanner.kone.com', 
    //   'studio':'https://www.kone.com/en/studio/tool/#/welcome'
    // },
    {
      'planner':'liftplaner.kone.ch', 
      'studio':'https://www.kone.ch/de/studio/tool/#/welcome'
    },
    {
      'planner':'planificateur-ascenseur.kone.ch', 
      'studio':'https://www.kone.ch/fr/studio/tool/#/welcome'
    },
  
    // {
    //   'planner':'kone-dev.conceptconfigurator.com', 
    //   'studio':'https://dev-pdc-endpoint.azureedge.net/#/welcome'
    // },
    // {
    //   'planner':'kone-dev.cpq.revalizesoftware.com', 
    //   'studio':'https://dev-pdc-endpoint.azureedge.net/#/welcome'
    // },
    // {
    //   'planner':'kone-test.cpq.revalizesoftware.com', 
    //   'studio':'https://qa-pdc-endpoint.azureedge.net/#/welcome'
    // },
  
  ]

function getParsedProduct(product:string, release:string):string {

  const releaseNumber = parseInt(release)
  let actualProduct = productMapping[product] || ' '

  if( ['H3W', 'M8C', 'L0C', 'Z4T'].indexOf(product) !== -1 && releaseNumber>1 ) {
    actualProduct += ' DX'
  }

  return actualProduct
}

function getParsedRelease(release:string):string {
  return releaseMapping[release]
}

function getParsedType(release:string):string {
  return typeMapping[release] || ' '
}

function checkEnaProduct(code:string):string {
  return enaProducts[code] || ' '
}

function getParsedCdType(release:string):string {
  return cardesignerMapping[release]
}

export function getUrlParams(): UrlParams {
  const url = window.location.href
  // const url = "https://download.kone.com/#/ADE/5/en:US/8579245994661080/KONE-123456"

  const [,,,, product, release, language, designId, configId] = url.split("/")

  const parsedProduct:string = getParsedProduct(product, release)
  const parsedRelease:string = getParsedRelease(release)
  const productType:string = getParsedType(product)
  const cdProductType:string = getParsedCdType(product) || ''
  let languageCode:string[] = language?.split(":") || ['en','US']
  if(languageCode.length>2) {
    languageCode.pop()
  }

  return {
    designId,
    configId,
    productCode: product,
    product: parsedProduct,
    language: languageCode.join("_"),
    localeFullCode: language,
    release: parsedRelease,
    productType,
    cdProductType
  }
}

export function getContactParams(): UrlParamsContact {
  const url = window.location.href
  // const url = "https://download.kone.com/#/ADE/5/en:US/8579245994661080/KONE-123456"

  const [,,,, contact, productType] = url.split("/")

  if(contact === 'contact' && productType !== undefined) {
    return {
      contact: true,
      productType
    }
  }

  return {
    contact:false,
    productType:'none'
  }

}

export function getProductIDForFeedback(productCode: string): string {
  
  // . 236324221 - Elevator planner, 909338214- ENA Elevator Planner, 261612571-Escalator planner

  if (getParsedType(productCode) === 'escalator') {
    return '261612571'
  }

  if (checkEnaProduct(productCode) !== ' ') {
    return '909338214'
  }

  return '236324221'

}

export function findMappingToStudio(plannerUrl:string):string|null {
  const foundMapping = plannerMapping.find((item:KeyValuePair) => item.planner === plannerUrl)
  if(!foundMapping) {
    return null
  }
  return foundMapping.studio
}